export default "__VITE_ASSET__BZ89IaEW__"